export const getFalsePositiveFilter = (filters) => {
  const falsePositiveFilter = {
    key: 'missed_reason',
    operator: 'choice:is',
    value: ['user_complaint'],
  };
  return filters.some(
    (filter) => JSON.stringify(filter) === JSON.stringify(falsePositiveFilter)
  );
};
